<template>
  <div class="area-tree">
    <div class="header" v-if="header">
      <span>行政区划</span>
      <div class="button-container">
        <el-button type="text" @click="addChild(null,null, $event)" v-if="editable">
          <i class="fa fa-plus-circle"></i>
          添加根节点
        </el-button>
      </div>
    </div>
    <el-tree
        ref="areaTree"
        v-bind="$attrs" v-on="$listeners"
        node-key="areaCode"
        @node-drag-start="handleDragStart"
        @node-drag-end="handleDragEnd"
        @current-change="nodeChange"
        :load="loadNodes"
        lazy
        :props="props"
        :draggable="editable"
        :allow-drop="allowDrop"
        :indent="16"
        :expand-on-click-node="false"
        class="container">
      <template v-slot:default="{node, data}">
        <div class="area-item" @click="handleClick(data)">
          <div class="area-item-title">
            <span :class="nodeColor(data)">
              <i :class="nodeIcon(node, data)"></i>
              {{data.areaName}}
            </span>
          </div>
          <div class="area-item-tool" v-if="editable">
            <el-button type="text" @click="addChild(data, node, $event)" v-if="!data.leaf">
              <el-image :src="require('@/assets/icons/add.svg')"/>
            </el-button>
            <el-button type="text" @click="del(data)">
              <el-image :src="require('@/assets/icons/delete.svg')"/>
            </el-button>
          </div>
        </div>
      </template>
    </el-tree>
  </div>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
export default {
  components: {},
  extends: BaseVue,
  props: {
    editable: {
      type: Boolean,
      default: false
    },
    parentCode: {
      type: String,
      default: "000000"
    },
    header: {
      type: Boolean,
      default: true
    },
    //是否只显示有效的数据
    valid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return{
      //拖拽的对象
      dragItem : null,
      //当前选中对象
      selectItem: null,
      //编辑对象
      editItem : null,
      props: {
        isLeaf: (data, node) => {
          return data.areaLevel === "4";
        }
      },
    }
  },
  created() {
  },
  methods: {
    loadNodes(node, resolve) {
      this.loading = true;
      this.postForm("/area/tree", {
        parentCode: node.level === 0 ? this.parentCode : node.data.areaCode,
        valid: this.valid === true ? true : null
      }, true).then(dr => {
        resolve(dr.rows);
      }).finally(()=>{
        this.loading = false;
      });
    },
    getTree(){
      return this.$refs["areaTree"];
    },

    //选中节点变化
    nodeChange(data, node){
      this.selectItem = data;
      this.$emit("node-change", data, node);
    },

    // toggleManage() {
    //   this.editable = !this.editable;
    // },

    allowDrop(draggingNode, dropNode, type) {
      if(dropNode.data.leaf && type === "inner") {
        return false;
      }
      return true;
    },

    handleDragStart(node, ev) {
      this.dragItem = node.data;
    },
    handleDragEnd(draggingNode, dropNode, dropType) {
      if(dropType === "none") {
        return;
      }
      let children = [];
      if(dropType === "inner") {
        draggingNode.data.parentCode = dropNode.data.areaCode;
        children = dropNode.childNodes;
      } else {
        //兄弟节点
        draggingNode.data.parentCode = dropNode.data.parentCode;
        children = dropNode.parent.childNodes;
      }

      this.save({
        areaCode: draggingNode.data.areaCode,
        parentCode: draggingNode.data.parentCode
      });

      // let ids = children.map((node,index)=>{
      //   console.log(node.data.areaCode+" "+node.data.areaName)
      //   return node.data.areaCode;
      // });
      // this.saveOrders(ids);
    },
    //添加模块
    addChild(data, node, ev) {
      if(node) {
        node.expand();
      }
      this.selectItem = null;
      this.$emit("add-child", data, node);
      ev.stopPropagation();
    },
    save(item) {
      this.loading = true;
      this.postForm("/area/save", item, true).then(dr => {
        if(this.editItem) {
          Object.assign(this.editItem, dr.bean);
          this.editItem = null;
        }
      }).finally(()=>{
        this.loading = false;
      })
    },

    // saveOrders(ids) {
    //   this.loading = true;
    //   this.$postForm("/area/saveOrders", {
    //     areaCodes: ids
    //   }).finally(()=>{
    //     this.loading = false;
    //   })
    // },

    del(item) {
      this.$confirm("确定要删除此行政区划吗？", "系统提示", {
        type: "warning"
      }).then(()=>{
        this.editItem = null;
        this.loading = true;
        this.postForm("/area/delete", {
          areaCode: item.areaCode
        }, true).then(dr => {
          this.getTree().remove(item);
          this.$emit("delete", item);
        }).finally(()=>{
          this.loading = false;
        })
      });
    },

    handleClick(item) {
      this.$emit("click", item);
    },

    // isLeaf(data, node){
    //   return !data.childrenCount && !node.childNodes.length;
    // },

    /**
     * 对外暴露方法，添加子节点
     * @param data 节点数据
     */
    append(data) {
      this.selectItem = Object.assign({}, data);
      this.getTree().append(this.selectItem, this.selectItem.parentCode);
      this.refresh(this.selectItem.parentCode);
    },
    /**
     * 重新加载树节点
     * @param node
     */
    reloadNode(node) {
      node.loaded = false;
      node.loadData();
    },
    /**
     * 刷新子节点
     * @param areaCode 节点ID
     */
    refresh(areaCode) {
      let areaTree = this.getTree();
      let node;
      if(!areaCode) {
        //刷新整棵树
        node = areaTree.root;
      }else{
        node = areaTree.getNode(areaCode);
      }
      if(node) {
        this.reloadNode(node);
      }
    },
    /**
     * 刷新父节点
     * @param areaCode
     */
    refreshParent(areaCode) {
      if(!areaCode) {
        this.refresh();
        return;
      }
      let node = this.getTree().getNode(areaCode);
      if(node) {
        this.reloadNode(node.parent);
      }
    },
    //返回节点颜色
    nodeColor(data) {
      if(!!this.selectItem && data.areaCode === this.selectItem.areaCode) {
        return "color-primary";
      }else if(!data.valid) {
        return "color-gray";
      }else{
        return "";
      }
    },
    //节点图标
    nodeIcon(node, data) {
      if(data.areaLevel === "4") {
        return "el-icon-document";
      } else {
        if(node.expanded) {
          return "el-icon-folder-opened";
        }
        return "el-icon-folder";
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/css/variables";
.area-tree{
  .header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid $color-border-primary;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    letter-spacing: 0.84px;
    line-height: 22px;
    font-weight: 600;
  }
  .container{
    ::v-deep .el-tree-node__content{
      height: 40px;
    }
    .area-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-grow: 1;
      &-title {
        line-height: 36px;
        flex-grow: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      &-tool {
        .el-button {
        }

        .el-button + .el-button {
          margin-left: 5px;
        }
      }

      .area-item.hover-bottom {
        border-bottom: 1px solid $color-primary;
      }

      .area-item:hover {
        background-color: rgba(0, 0, 0, 0.05);
      }

      .job-type-sub-list {
        .area-item {
          padding-left: 20px;
        }
      }
    }
  }
}

</style>